(function ($) {
    $(document).ready(function () {
        var dateFields = $('input[data-mask-type=date]');
        if (dateFields.length) {
            dateFields.mask('99/99/9999').bind('keypress', function (e) {
                if (e.which === 9) {
                    jQuery(this).blur();
                }
            }).data('masked', 'true');
        }
        var ssns = $('input[data-mask-type=ssn]');
        if (ssns.length) {
            ssns.mask('999-99-9999').bind('keypress', function (e) {
                if (e.which === 11) {
                    jQuery(this).blur();
                }
            }).data('masked', 'true');
        }

        var states = $('input[data-mask-type=state]');
        if (states.length) {
            states.mask('aa').bind('keypress', function (e) {
                if (e.which === 11) {
                    jQuery(this).blur();
                }
            }).data('masked', 'true');
        }

        var forms = $('.gform_wrapper').find('form');
        if (forms.length) {
            forms.bind('DOMSubtreeModified', function (e) {
                var form = $(this);

                var dateFields = form.find('input[data-mask-type=date]:not(input[data-masked=true])');
                dateFields.mask('99/99/9999').bind('keypress', function (e) {
                    if (e.which === 9) {
                        jQuery(this).blur();
                    }
                }).data('masked', 'true');

                var ssns = form.find('input[data-mask-type=ssn]:not([data-masked=true])');
                ssns.mask('999-99-9999').bind('keypress', function (e) {
                    if (e.which === 11) {
                        jQuery(this).blur();
                    }
                }).data('masked', 'true');
            });
        }
    });
})(jQuery);